<div class="listado__stats">
    <div class="listado__stat">
        <div class="listado__stat-value">{{ totalLogs }}</div>
        <div class="listado__stat-label">{{ 'COMMON.TOTAL' | translate }}</div>
    </div>
    <div class="listado__stat">
        <div class="listado__stat-value is-muted">{{ logsMostrados }}</div>
        <div class="listado__stat-label">{{ 'COMMON.SHOWING' | translate }}</div>
    </div>
</div>

<button type="button" class="filters-trigger" (click)="filtersOpen = !filtersOpen">
    <mat-icon>tune</mat-icon>
    {{ 'COMMON.FILTERS' | translate }}<span *ngIf="activeFilterCount > 0" class="filter-count">&nbsp;{{ activeFilterCount }}</span>
</button>

<div class="listado__toolbar" [class.is-open]="filtersOpen">
    <div class="listado__filter listado__toolbar-fields">
        <div class="filter-sheet__grip"></div>
        <div class="filter-sheet__head">
            <span>{{ 'COMMON.FILTERS' | translate }}{{ activeFilterCount > 0 ? ' (' + activeFilterCount + ')' : '' }}</span>
            <button type="button" (click)="filtersOpen = false">×</button>
        </div>

        <input type="text" class="em-input" [formControl]="filtroIP" [placeholder]="'ERRORES.PH_IP' | translate">
        <input type="text" class="em-input" [formControl]="filtroMensaje" [placeholder]="'ERRORES.PH_MSG' | translate">
        <div class="em-date-range" [formGroup]="filtroFecha">
            <input type="date" class="em-input" formControlName="start" [attr.aria-label]="'COMMON.DATE_START' | translate">
            <span class="em-date-range__sep">–</span>
            <input type="date" class="em-input" formControlName="end" [attr.aria-label]="'COMMON.DATE_END' | translate">
        </div>
        <div class="toggle-container">
            <label class="fb-toggle listado__toggle">
                <input type="checkbox" [formControl]="filtroCargaTotal" [disabled]="cargandoTramites">
                <span class="fb-toggle__track">
                    <span class="fb-toggle__thumb"></span>
                </span>
                <span class="fb-toggle__text">{{ 'ERRORES.LOAD_ALL' | translate }}</span>
            </label>
        </div>
        <div class="filter-sheet__foot">
            <button type="button" class="em-btn" (click)="clearFilters()">{{ 'COMMON.CLEAR' | translate }}</button>
            <button type="button" class="em-btn em-btn--primary" (click)="filtersOpen = false">{{ 'COMMON.APPLY' | translate }}</button>
        </div>
    </div>
</div>

<div class="listado listado--cards-accent">
    <mat-table *ngIf="dataSource" #table [dataSource]="dataSource" matSort matSortActive="Fecha" matSortDirection="desc" class="table align-middle mb-0 bg-white">
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column === 'Acciones'" sortActionDescription="Sort by {{column}}" class="header" [class.em-th-actions]="column === 'Acciones'">
                {{ colLabel(column) }}
            </mat-header-cell>

            <ng-container *ngIf="column === 'Acciones'">
                <mat-cell *matCellDef="let object" class="mat-cell em-td-actions" data-role="actions">
                    <div class="em-actions-wrap">
                        <button type="button" class="em-icon-btn"
                            *ngIf="object['Stack Trace']"
                            [matTooltip]="'ERRORES.TOOLTIP_COPY' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="copyStackTrace(object['Stack Trace'])">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column === 'Stack Trace'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="colLabel(column)"
                    [style]="valuesEnum(object[column])?'color: #025677;':''">
                    <span *ngIf="object[column]; else noStack">{{ object[column].length > 80 ? (object[column] | slice:0:80) + '…' : object[column] }}</span>
                    <ng-template #noStack>—</ng-template>
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column !== 'Stack Trace' && column !== 'Acciones'">
                <ng-container *ngIf="column === 'Fecha'">
                    <mat-cell *matCellDef="let object" class="mat-cell"
                        [attr.data-label]="colLabel(column)"
                        data-role="meta"
                        [style]="valuesEnum(object[column])?'color: #025677;':''">
                        {{ formatTimestamp(object[column]) }}
                    </mat-cell>
                </ng-container>
                <ng-container *ngIf="column !== 'Fecha'">
                    <mat-cell *matCellDef="let object" class="mat-cell"
                        [attr.data-label]="column === 'Nombre del Hilo' ? ('ERRORES.THREAD_SHORT' | translate) : colLabel(column)"
                        [attr.data-role]="column === 'Origen' ? 'title' : null"
                        [style]="valuesEnum(object[column])?'color: #025677;':''">
                        {{ object[column] }}
                    </mat-cell>
                </ng-container>
            </ng-container>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
    </mat-paginator>

    <div class="load-more-row" *ngIf="paginator?.hasNextPage()">
        <button type="button" class="load-more-btn" (click)="cargarMas()">{{ 'COMMON.LOAD_MORE' | translate }}</button>
    </div>

    <form (submit)="exportarCsv()">
        <button *ngIf="dataSource && isAdmin" class="btn btn-primary m-left" type="submit" (click)="mostrarSpinnerMsg(translate.instant('COMMON.GENERATING_CSV'))">{{ 'COMMON.EXPORT_CSV' | translate }}</button>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'litado_errores_spinner'">
    <p style="color: white">{{ mensajeSpinner }}</p>
</ngx-spinner>
